import gql from 'graphql-tag';

export const REGISTER_USER_MUTATION = gql`
    mutation registerUser($input: RegisterUserInput!) {
        registerUser(input: $input) {
            success
            pageAfterLoginUrl
            errorMessage
            errorCode
            errorField
        }
    }
`;

export type RegisterUserInput = {
    email: string;
    password: string;
    propertyStatus: string;
    consents: Array<ConsentsInput>;
};

export type RegisterUserPayload = {
    success: boolean;
    pageAfterLoginUrl: string | null;
    errorMessage: string | null;
    errorCode: string | null;
    errorField: string | null;
};

export type ConsentsInput = {
    consentName: string;
    consentGiven: boolean | string;
};
